import { useEffect, useState } from "react";
import { Container } from "../../../Components/Player/PokeCard/styles";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Flex,
  FloatButton,
  Form,
  Input,
  Modal,
  Select,
  Space,
} from "antd";
import {
  EditOutlined,
  ArrowLeftOutlined,
  MailOutlined,
  InstagramOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useListarEntrenadores, useEditarPerfil } from "../../../Hooks/Player";

export const EditarPerfil = () => {
  const apiListEntrenadores = useListarEntrenadores();
  const apiEditarPerfil = useEditarPerfil();

  const storedDataUser = JSON.parse(localStorage.getItem("dataUser"));

  const navigate = useNavigate();

  const [modalAvatar, setModalAvatar] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [configurarData, setConfigurarData] = useState({
    user: true,
    correo: true,
    ig: true,
  });

  useEffect(() => {
    const shouldEnableButton = Object.values(configurarData).some(
      (value) => value === false
    );
    setIsButtonDisabled(!shouldEnableButton);
  }, [configurarData]);

  const defaultValue = [
    {
      name: ["user_name"],
      value: storedDataUser.usua_nombre,
    },
    {
      name: ["user_correo"],
      value: storedDataUser.usua_correo,
    },
    {
      name: ["user_instagram"],
      value: storedDataUser.usua_ig,
    },
  ];
  return (
    <Container color={"rgba(0, 0, 0, 0.7)"}>
      <FloatButton
        icon={<ArrowLeftOutlined />}
        style={{ left: 10, top: 10 }}
        onClick={() => navigate("/configuracion")}
      />

      <Flex vertical>
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            alt="pokemoneda"
            src={storedDataUser.imag_url}
            style={{
              display: "block",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              width: "50%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "0.5rem",
              marginTop: "3rem",
            }}
          />

          {/* Botón de Editar */}
          <Button
            icon={<EditOutlined />}
            style={{
              position: "absolute",
              right: 50,
              top: 35,
            }}
            onClick={() => setModalAvatar(true)}
          />
        </div>

        <Form
          name="Editar_perfil"
          layout="vertical"
          autoComplete="off"
          onFinish={(e) => {
            // console.log("cambiar: ", e);
          }}
          fields={defaultValue}
        >
          <Form.Item
            name="user_name"
            rules={[
              {
                required: !configurarData.user,
                message: "Usuario es requerido.",
              },
            ]}
            hasFeedback
            style={{ marginTop: "1.5rem" }}
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                prefix={<UserOutlined />}
                defaultValue={storedDataUser.usua_nombre}
                style={{
                  background: "rgba(0, 0, 0, 0)",
                  borderColor: configurarData.user ? "#848484" : "#FFF",
                  color: configurarData.user ? "#848484" : "#FFF",
                }}
                disabled={configurarData.user}
              />
              <Button
                icon={<EditOutlined />}
                style={{ background: "rgba(0, 0, 0, 0)", color: "#FFF" }}
                onClick={(e) =>
                  setConfigurarData({
                    user: false,
                    correo: configurarData.correo,
                    ig: configurarData.ig,
                  })
                }
              />
            </Space.Compact>
          </Form.Item>

          <Form.Item
            name="user_correo"
            rules={[
              {
                required: !configurarData.correo,
                message: "Correo es requerido.",
              },
            ]}
            hasFeedback
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                prefix={<MailOutlined />}
                defaultValue={storedDataUser.usua_correo}
                style={{
                  background: "rgba(0, 0, 0, 0)",
                  borderColor: configurarData.correo ? "#848484" : "#FFF",
                  color: configurarData.correo ? "#848484" : "#FFF",
                }}
              />
              <Button
                icon={<EditOutlined />}
                style={{ background: "rgba(0, 0, 0, 0)", color: "#FFF" }}
                onClick={(e) =>
                  setConfigurarData({
                    user: configurarData.user,
                    correo: false,
                    ig: configurarData.ig,
                  })
                }
              />
            </Space.Compact>
          </Form.Item>

          <Form.Item
            name="user_instagram"
            rules={[
              {
                required: !configurarData.ig,
                message: "Instagram es requerido.",
              },
            ]}
            hasFeedback
          >
            <Space.Compact style={{ width: "100%" }}>
              <Input
                prefix={<InstagramOutlined />}
                defaultValue={storedDataUser.usua_ig}
                style={{
                  background: "rgba(0, 0, 0, 0)",
                  borderColor: configurarData.ig ? "#848484" : "#FFF",
                  color: configurarData.ig ? "#848484" : "#FFF",
                }}
              />
              <Button
                icon={<EditOutlined />}
                style={{ background: "rgba(0, 0, 0, 0)", color: "#FFF" }}
                onClick={(e) =>
                  setConfigurarData({
                    user: configurarData.user,
                    correo: configurarData.correo,
                    ig: false,
                  })
                }
              />
            </Space.Compact>
          </Form.Item>

          <Form.Item>
            <Flex justify="end">
              <Button
                htmlType="submit"
                style={{
                  backgroundColor: isButtonDisabled
                    ? "rgba(0, 0, 0, 0)"
                    : "#201c1c",
                  border: !isButtonDisabled && "none",
                  color: isButtonDisabled ? "#848484" : "#FFF",
                }}
                disabled={isButtonDisabled}
              >
                Guardar
              </Button>
            </Flex>
          </Form.Item>
        </Form>
        <h3 style={{ color: "#FFFF" }}>Nueva Contraseña</h3>
        <Form
          name="nueva_contraseña"
          layout="vertical"
          autoComplete="off"
          onFinish={(e) => {
            // console.log("cambiar: ", e);
          }}
        >
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Contraseña es requerida.",
              },
            ]}
            hasFeedback
          >
            <Input.Password
              placeholder="Nueva Contraseña"
              style={{
                background: "rgba(0, 0, 0, 0)",
                borderColor: "#FFF",
                color: "#FFF",
              }}
            />
          </Form.Item>

          <Form.Item
            name="password_2"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Por favor confirma tu contraseña!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("La contraseña no coincide!")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirma tu contraseña"
              style={{
                background: "rgba(0, 0, 0, 0)",
                borderColor: "#FFF",
                color: "#FFF",
              }}
            />
          </Form.Item>

          <Form.Item>
            <Flex justify="end">
              <Button
                htmlType="submit"
                style={{
                  backgroundColor: "#201c1c",
                  border: "none",
                  color: "#FFF",
                }}
              >
                Cambiar
              </Button>
            </Flex>
          </Form.Item>
        </Form>
      </Flex>

      {modalAvatar && (
        <Modal
          title="Avatar"
          open={modalAvatar}
          footer={null}
          onCancel={() => setModalAvatar(false)}
        >
          <Form
            name="avatar"
            layout="vertical"
            autoComplete="off"
            onFinish={async (e) => {
              if (e) {
                await apiEditarPerfil.mutateAsync({
                  idEntrenador: storedDataUser.id,
                  imag_id: e.avatar,
                });
                setModalAvatar(false)
              
              }
            }}
          >
            <Form.Item name="avatar" label="Selecciona un entrenador">
              <Select
                defaultValue={storedDataUser.imag_id}
                options={apiListEntrenadores.data ?? []}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button htmlType="submit" type="primary">
                  Cambiar
                </Button>
                <Button htmlType="reset">Borrar</Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </Container>
  );
};
